export const FORMALITY_CATEGORY_IMMATRICULATION = 1;
